class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.querySelectorAll('details').forEach((details) => {
      details.addEventListener('mouseenter', this.onMouseEnterDetails.bind(this, details));
      details.addEventListener('mouseleave', this.onMouseLeaveDetails.bind(this, details));
    });
  }

  onMouseEnterDetails(detailsElement) {
    if (window.matchMedia('(min-width: 990px)').matches) {
      if (detailsElement._hoverTimer) {
        clearTimeout(detailsElement._hoverTimer);
        detailsElement._hoverTimer = null;
      }
      detailsElement.setAttribute('open', '');
      const summary = detailsElement.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', true);
    }
  }

  onMouseLeaveDetails(detailsElement) {
    if (window.matchMedia('(min-width: 990px)').matches) {
      detailsElement._hoverTimer = setTimeout(() => {
        detailsElement.removeAttribute('open');
        const summary = detailsElement.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', false);
      }, 150);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
